/*
 * Copyright (c) 2023 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { memo } from 'react';
import { IconButton, TableCell, Theme, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useTranslation } from 'react-i18next';
import { TableTooltip } from '../../StyledComponents/TableTooltip';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import DownloadIcon from '@mui/icons-material/Download';
import { theme } from '../../../assets/style/them';
import {
    DelayedDownloadingStatus,
    DelayedDownloadingsListItemDto,
    FileInfo,
} from '../../../data/api/downloadings/downloadingsClient.typings';
import { generateDownloadedFileName } from '../DelayedDownloadingsConfig';

const useStyles = makeStyles((theme: Theme) => ({
    managementCell: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        padding: theme.spacing(0.5),
        color: theme.palette.text.secondary,
    },
    managementTextCell: {
        padding: theme.spacing(1.5, 1),
    },
}));

interface FileManagementCellProps {
    fileDto: DelayedDownloadingsListItemDto;
    onDeleteFile(fileDto: DelayedDownloadingsListItemDto): void;
    onDownloadFile(file: FileInfo): void;
}

const FileManagementCell = (props: FileManagementCellProps) => {
    const classes = useStyles();
    const { t } = useTranslation();

    const { fileDto, onDeleteFile, onDownloadFile } = props;

    return (
        <TableCell className={classes.managementCell}>
            {fileDto.status === DelayedDownloadingStatus.Ready || fileDto.status === DelayedDownloadingStatus.Error ? (
                <>
                    {fileDto.status === DelayedDownloadingStatus.Ready ? (
                        <TableTooltip title={t('app.download')} placement="top">
                            <IconButton
                                onClick={() =>
                                    onDownloadFile({
                                        fileNameS3: fileDto.name,
                                        fileNameForUser: generateDownloadedFileName(fileDto),
                                        id: fileDto.id,
                                    })
                                }
                                size="large"
                            >
                                <DownloadIcon style={{ color: theme.palette.primary.main }} />
                            </IconButton>
                        </TableTooltip>
                    ) : null}

                    <TableTooltip title={t('app.delete')} placement="top">
                        <IconButton onClick={() => onDeleteFile(fileDto)} size="large">
                            <DeleteForeverIcon style={{ color: theme.palette.error.main }} />
                        </IconButton>
                    </TableTooltip>
                </>
            ) : (
                <Typography className={classes.managementTextCell}>{'-'}</Typography>
            )}
        </TableCell>
    );
};
export default memo(FileManagementCell);
